// src/components/DemoModal.jsx

import { useState } from "react";

// Telegram Bot Configuration
const TELEGRAM_BOT_TOKEN = "8854560272:AAEaHusKEyfpGidVgKwS0VB6YSksLtyyDh8";
const TELEGRAM_CHAT_ID = ""; // Заполните после отправки сообщения боту

const DemoModal = ({ show, onClose }) => {
  const [formData, setFormData] = useState({
    name: "",
    company: "",
    email: "",
    phone: "",
    devices: "",
    message: "",
  });
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [sendError, setSendError] = useState(null);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const sendMessageToTelegram = async (data) => {
    if (!TELEGRAM_BOT_TOKEN || !TELEGRAM_CHAT_ID) {
      console.warn("Telegram credentials not configured. Demo request logged locally.");
      console.log("Demo request:", data);
      return true;
    }

    const message = `
🔔 <b>Новая заявка на демо ТСМ</b>

👤 <b>Имя:</b> ${data.name}
🏢 <b>Компания:</b> ${data.company}
📧 <b>Email:</b> ${data.email}
📱 <b>Телефон:</b> ${data.phone || "—"}
📊 <b>Устройств:</b> ${data.devices || "—"}

💬 <b>Комментарий:</b>
${data.message || "Нет комментария"}

——
_Заявка отправлена с dev-abs.ru_
    `.trim();

    const url = `https://api.telegram.org/bot${TELEGRAM_BOT_TOKEN}/sendMessage`;
    
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          chat_id: TELEGRAM_CHAT_ID,
          text: message,
          parse_mode: "HTML",
        }),
      });

      if (!response.ok) {
        throw new Error(`Telegram API error: ${response.status}`);
      }

      return true;
    } catch (err) {
      console.error("Failed to send Telegram message:", err);
      throw err;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setSendError(null);

    try {
      await sendMessageToTelegram(formData);
      setSubmitted(true);
      setTimeout(() => {
        setSubmitted(false);
        setFormData({ name: "", company: "", email: "", phone: "", devices: "", message: "" });
        onClose();
      }, 4000);
    } catch (err) {
      setSendError("Не удалось отправить заявку. Попробуйте позже.");
      console.error("Submit error:", err);
    } finally {
      setLoading(false);
    }
  };

  if (!show) return null;

  return (
    <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
      <div className="modal-dialog modal-dialog-centered modal-lg">
        <div className="modal-content" style={{ border: "none", borderRadius: "12px", overflow: "hidden" }}>
          <div className="modal-header" style={{ borderBottom: "1px solid var(--color-border)", padding: "1.25rem 1.5rem" }}>
            <div>
              <h5 className="modal-title" style={{ fontWeight: 700, margin: 0 }}>Запросить демонстрацию</h5>
              <p className="text-muted mb-0" style={{ fontSize: "0.875rem" }}>Заполните форму и мы покажем систему в действии</p>
            </div>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
              aria-label="Close"
            />
          </div>
          
          <form onSubmit={handleSubmit}>
            <div className="modal-body p-4">
              {sendError && (
                <div className="alert alert-danger" role="alert" style={{ marginBottom: "1rem" }}>
                  {sendError}
                </div>
              )}

              <div className="row">
                <div className="col-md-6 mb-3">
                  <label className="form-label-custom">Имя *</label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="Ваше имя"
                    required
                    className="form-control-custom"
                  />
                </div>
                <div className="col-md-6 mb-3">
                  <label className="form-label-custom">Компания *</label>
                  <input
                    type="text"
                    name="company"
                    value={formData.company}
                    onChange={handleChange}
                    placeholder="Название компании"
                    required
                    className="form-control-custom"
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-md-6 mb-3">
                  <label className="form-label-custom">Email *</label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="email@company.ru"
                    required
                    className="form-control-custom"
                  />
                </div>
                <div className="col-md-6 mb-3">
                  <label className="form-label-custom">Телефон</label>
                  <input
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    placeholder="+7 (___) ___-__-__"
                    className="form-control-custom"
                  />
                </div>
              </div>

              <div className="mb-3">
                <label className="form-label-custom">Количество устройств</label>
                <select
                  name="devices"
                  value={formData.devices}
                  onChange={handleChange}
                  className="form-control-custom"
                >
                  <option value="">Выберите диапазон</option>
                  <option value="1-100">1 — 100 устройств</option>
                  <option value="100-500">100 — 500 устройств</option>
                  <option value="500-1000">500 — 1 000 устройств</option>
                  <option value="1000-5000">1 000 — 5 000 устройств</option>
                  <option value="5000+">Более 5 000 устройств</option>
                </select>
              </div>

              <div className="mb-4">
                <label className="form-label-custom">Комментарий</label>
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  placeholder="Расскажите о вашей инфраструктуре и задачах..."
                  rows={4}
                  className="form-control-custom"
                  style={{ resize: "vertical" }}
                />
              </div>
            </div>

            <div className="modal-footer" style={{ borderTop: "1px solid var(--color-border)", padding: "1.25rem 1.5rem" }}>
              <button
                type="button"
                className="btn btn-outline-custom"
                onClick={onClose}
                style={{ minWidth: "100px" }}
              >
                Отмена
              </button>
              <button
                type="submit"
                className="btn btn-primary-custom"
                disabled={loading}
                style={{ minWidth: "200px" }}
              >
                {loading && (
                  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                )}
                {loading ? "Отправка..." : "Запросить демо"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default DemoModal;
